import { ListItem, Stack, Typography } from '@mui/material';
import { Link, ReferenceField } from 'react-admin';

import { AccountAvatar } from '../accounts/AccountAvatar';
import type { ActivityQuoteCreated } from '../types';
import { SaleName } from '../sales/SaleName';
import { RelativeDate } from '../misc/RelativeDate';
import { useActivityLogContext } from './ActivityLogContext';

type ActivityLogQuoteCreatedProps = {
    activity: ActivityQuoteCreated;
};

export function ActivityLogQuoteCreated({
    activity,
}: ActivityLogQuoteCreatedProps) {
    const context = useActivityLogContext();
    const { quote } = activity;
    return (
        <ListItem disableGutters>
            <Stack direction="row" spacing={1} alignItems="center" width="100%">
                <ReferenceField
                    source="account_id"
                    reference="accounts"
                    record={activity}
                    link={false}
                >
                    <AccountAvatar width={20} height={20} />
                </ReferenceField>
                <Typography
                    component="p"
                    variant="body2"
                    color="text.secondary"
                    flexGrow={1}
                >
                    <ReferenceField
                        source="sales_id"
                        reference="sales"
                        record={activity}
                        link={false}
                    >
                        <SaleName />
                    </ReferenceField>{' '}
                    added quote{' '}
                    <Link to={`/quotes/${quote.id}/show`}>{quote.name}</Link>{' '}
                    {context !== 'account' && (
                        <>
                            to account{' '}
                            <ReferenceField
                                source="account_id"
                                reference="accounts"
                                record={activity}
                                link="show"
                            />{' '}
                            <RelativeDate date={activity.date} />
                        </>
                    )}
                </Typography>
                {context === 'account' && (
                    <Typography
                        color="textSecondary"
                        variant="body2"
                        component="span"
                    >
                        <RelativeDate date={activity.date} />
                    </Typography>
                )}
            </Stack>
        </ListItem>
    );
}
